/**
 * Backend Service
 * 
 * Simple service for communicating with the IMO backend.
 * Handles health checks and basic backend operations.
 */

import axios from 'axios';
import { getBackendUrl } from '../utils/backendUrl';

const BACKEND_API_URL = getBackendUrl();

class BackendService {
  /**
   * Check if backend is healthy and reachable
   */
  async checkHealth(): Promise<boolean> {
    try {
      const response = await axios.get(`${BACKEND_API_URL}/health`, {
        timeout: 5000
      });
      return response.data.success === true;
    } catch (error) {
      console.error('Backend health check failed:', error);
      return false;
    }
  }

  /**
   * Get backend URL for debugging
   */
  getBackendUrl(): string {
    return BACKEND_API_URL;
  }
}

// Export singleton instance
export const backendService = new BackendService();
